export const enum BranchType {
  RENTUP = 'RENTUP',
  KODI_TECH = 'KODI_TECH',
  WESUB = 'WESUB',
  ARGAN = 'ARGAN',
  CONSULTING = 'CONSULTING',
  CREDIT = 'CREDIT',
  B2C = 'B2C',
}
